import { WeblogPageCategory, WeblogScreenName } from '../../../shared/constants/weblog';
import DomainManager from '../../../shared/utils/DomainManager';
import { useEnvContext } from '../../../modules/EnvProvider';
import { sendClickLog } from '../../utils/sendClickLog';

import GlobalNavNonLineButton from './GlobalNavNonLineButton';
import GlobalNavOutLineButton from './GlobalNavOutLineButton';
import { getSigninWebLink } from '../../utils/getSigninWebLink';

type Props = {
  className?: string;
  label: string;
  redDot?: boolean;
  outline?: boolean;
  pathname: string;
};

export default function GlobalNavLink({ className, label, pathname, redDot, outline }: Props) {
  const { targetEnv } = useEnvContext();

  const domainManager = new DomainManager(targetEnv);

  const handleClick = () => {
    const targetUrl = pathname.startsWith('http')
      ? pathname
      : `${domainManager.getTravelerServiceDomain()}${pathname}`;

    sendClickLog({
      eventName: 'topmenu',
      screenName: WeblogScreenName.COMMON,
      pageCategory: WeblogPageCategory.COMMON,
      itemKind: 'menu',
      itemName: label,
      targetUrl,
    });

    if (pathname.includes('/users/sign_in')) {
      window.location.href = getSigninWebLink(targetEnv);

      return;
    }

    window.location.href = targetUrl;
  };

  return (
    <>
      {outline && (
        <GlobalNavOutLineButton
          className={className}
          label={label}
          redDot={redDot}
          onClick={handleClick}
        />
      )}
      {!outline && (
        <GlobalNavNonLineButton
          className={className}
          label={label}
          redDot={redDot}
          onClick={handleClick}
        />
      )}
    </>
  );
}
